import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { CalendarDays, TrendingUp, TrendingDown, Star } from 'lucide-react';

export default function WeeklyDigestCard() {
  const [digest, setDigest] = useState(null);
  const [state, setState] = useState('loading'); // loading | ready | empty

  useEffect(() => {
    api.get('/portfolio/weekly_digest')
      .then(r => {
        if (r.data.digest) {
          setDigest(r.data.digest);
          setState('ready');
        } else setState('empty');
      })
      .catch(() => setState('empty'));
  }, []);

  if (state === 'loading') return null;

  return (
    <div className="mt-10 border border-[#0ECB81]/25 bg-gradient-to-br from-[#0ECB81]/8 via-[#181A20] to-[#181A20] p-5" data-testid="weekly-digest-card">
      <div className="flex items-center gap-2 mb-3">
        <CalendarDays className="w-5 h-5 text-[#0ECB81]" />
        <h2 className="text-white text-lg font-semibold">Your Weekly Digest</h2>
        <span className="text-xs uppercase tracking-wider text-[#848E9C]">emailed every Sunday 20:00 UTC</span>
      </div>
      {state === 'empty' || !digest ? (
        <div className="text-sm text-[#B7BDC6]">
          Not enough activity this week yet — your digest will show up here after a few days of snapshots.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div className="border border-[#2B3139] bg-[#0B0E11] p-3">
            <div className="text-xs uppercase text-[#848E9C]">Weekly Peak</div>
            <div className="font-mono text-[#FCD535] text-2xl mt-1">${digest.peak_value_usd.toLocaleString()}</div>
            <div className="text-[10px] text-[#5E6673]">Across {digest.days} snapshot days</div>
          </div>
          <div className="border border-[#2B3139] bg-[#0B0E11] p-3">
            <div className="text-xs uppercase text-[#848E9C]">Change vs Week Start</div>
            <div className={`font-mono text-2xl mt-1 flex items-center gap-1 ${digest.delta_pct >= 0 ? 'text-[#0ECB81]' : 'text-[#F6465D]'}`}>
              {digest.delta_pct >= 0 ? <TrendingUp className="w-5 h-5" /> : <TrendingDown className="w-5 h-5" />}
              {digest.delta_pct >= 0 ? '+' : ''}{digest.delta_pct.toFixed(2)}%
            </div>
            <div className="text-[10px] text-[#5E6673]">From ${digest.start_value_usd.toLocaleString()}</div>
          </div>
          {digest.best_coin ? (
            <div className="border border-[#FCD535]/30 bg-[#FCD535]/8 p-3" data-testid="digest-best-coin">
              <div className="text-xs uppercase text-[#848E9C] flex items-center gap-1"><Star className="w-3 h-3 text-[#FCD535]" /> Best Coin</div>
              <div className="flex items-center gap-2 mt-1.5">
                {digest.best_coin.image && <img src={digest.best_coin.image} alt="" className="w-7 h-7" />}
                <div>
                  <div className="text-white font-semibold text-sm">{digest.best_coin.symbol}</div>
                  <div className={`text-xs font-mono ${digest.best_coin.change_24h >= 0 ? 'text-[#0ECB81]' : 'text-[#F6465D]'}`}>
                    {digest.best_coin.change_24h >= 0 ? '+' : ''}{digest.best_coin.change_24h}% 24h
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="border border-[#2B3139] bg-[#0B0E11] p-3">
              <div className="text-xs uppercase text-[#848E9C]">Best Coin</div>
              <div className="text-sm text-[#5E6673] mt-2 italic">No holdings tracked</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
